import { Dispatch } from 'redux';
import { BookAction, bookActionTypes } from '../type';
import { getWords } from '../../api/fetchWords';
import { wordsResponse } from '../../types';

export const fetchWords = (group = 0, page = 0) => {
  return async (dispatch: Dispatch<BookAction>) => {
    try {
      dispatch({
        type: bookActionTypes.FETCH_WORDS,
      });
      getWords(page, group).then((data) => {
        dispatch({ type: bookActionTypes.FETCH_WORDS_SUCCESS, payload: data as wordsResponse[] });
      });
    } catch (e) {}
  };
};

export const setGroupTextbook = (group: number) => {
  return { type: bookActionTypes.SET_GROUP, payload: group };
};

export function removeWords() {
  return { type: bookActionTypes.REMOVE_WORDS };
}

export const setPageTextbook = (page: number) => {
  return { type: bookActionTypes.SET_PAGE, payload: page };
};
